(() => {
  if (window.GrowplayNavDisclosure) return;
  const controllers = new Map();
  function init(scope = document) {
    scope.querySelectorAll('.gp-nav-disclosure').forEach(root => {
      if (controllers.has(root)) return;
      const toggle = root.querySelector('[data-gp-nav-toggle]');
      const panel = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      let hovered = false;
      let suppressFocus = false;
      const setOpen = open => {
        root.classList.toggle('is-opened', open);
        toggle.setAttribute('aria-expanded', String(open));
        panel.inert = !open;
      };
      const enter = () => { hovered = true; setOpen(true); };
      const leave = () => { hovered = false; if (!root.contains(document.activeElement)) setOpen(false); };
      const focusIn = event => {
        if (!suppressFocus && event.target !== toggle) setOpen(true);
      };
      const focusOut = event => { if (!hovered && !root.contains(event.relatedTarget)) setOpen(false); };
      const click = () => setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      const keydown = event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          suppressFocus = true;
          setOpen(false);
          toggle.focus();
          suppressFocus = false;
        } else if (event.key === 'ArrowDown') {
          event.preventDefault();
          setOpen(true);
          panel.querySelector('a[href], button')?.focus();
        }
      };
      root.addEventListener('mouseenter', enter);
      root.addEventListener('mouseleave', leave);
      root.addEventListener('focusin', focusIn);
      root.addEventListener('focusout', focusOut);
      root.addEventListener('keydown', keydown);
      toggle.addEventListener('click', click);
      setOpen(false);
      controllers.set(root, () => {
        root.removeEventListener('mouseenter', enter);
        root.removeEventListener('mouseleave', leave);
        root.removeEventListener('focusin', focusIn);
        root.removeEventListener('focusout', focusOut);
        root.removeEventListener('keydown', keydown);
        toggle.removeEventListener('click', click);
      });
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => controllers.forEach((cleanup, root) => {
    if (event.target.contains(root)) { cleanup(); controllers.delete(root); }
  }));
  window.GrowplayNavDisclosure = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
